import { render } from "./CategoryBottomSheet.vue?vue&type=template&id=547b3030&scoped=true"
import script from "./CategoryBottomSheet.vue?vue&type=script&lang=js"
export * from "./CategoryBottomSheet.vue?vue&type=script&lang=js"

import "./CategoryBottomSheet.vue?vue&type=style&index=0&id=547b3030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547b3030"]])

export default __exports__